import React, { useEffect, useState, useRef } from 'react';
import styles from './styles';
import {
  getInventoryShareLink,
  getPortsList,
  getTerminalsList,
  getVesselSchedule,
  getAllVesselSchedule,
  getSslVesselSchedule,
  getVesselTableTitlesList,
  setUserSettings,
  adminChangeVesselFieldData,
  getSslList,
  SaveApiResMessage,
} from '@/actions';
import Pagination from '@/components/pagination';
import { useSelector } from 'react-redux';
import { Icons, TerminalsIcon } from '@/assets';
import { ReactSVG } from 'react-svg';
import { Tooltip, Grid, TextField, Button } from '@material-ui/core';
import DateInput from '@/components/DateInput';
import clsx from 'clsx';
import Select from 'react-select';
import { getGateSchedule } from '@/actions';
import { useNotify } from 'react-admin';
import { FormHelperText } from '@mui/material';
import EditFields from './editFields';
import LoadingV2 from '@/components/Loading';

export default ({}) => {
  const cls = styles();
  const notify = useNotify();
  // const [Vessels, setVessels] = React.useState(VesselsList);
  const setForm = (it, val) => setFormData({ ...form, [it]: val });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const [vesselsState, setVesselsState] = useState({
    loading: false,
    VesselsList: [],
  });
  const [lazyLoading, setLazyLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState({
    DATA: null,
    loading: true,
    popUp: false,
  });

  const createArrayFromNumbers = (number) => {
    let numberArray = [];
    for (let i = 1; i <= number; i++) {
      numberArray.push(i);
    }

    return numberArray;
  };

  const [form, setFormData] = React.useState({
    size: null,
    ssl: null,
    vessel: '',
    date: new Date(),
    count: '',
    loc: null,
    containers: [],
    port: '',
    terminal: '',
    etaDate: new Date(),
    etdDate: new Date(),
    erdDate: new Date(),
    cotoffDate: new Date(),
  });

  const [loading, setLoading] = React.useState(false);
  const [tableSetting, setTableSetting] = React.useState('unchangable');
  const [VesselsEnd, seVesselsEnd] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  // const [tableTitlesList, setTableTitlesList] = React.useState();
  const [filterOpenStatus, setFilterOpenStatus] = useState('close');
  const [dataTypeChange, setdataTypeChange] = useState('all');
  const [priorityChange, setPriorityChange] = useState('priorityTerminal');
  const [selectedPort, setSelectedPort] = useState('All');
  const [selectedTerminal, setSelectedTerminal] = useState('All');
  const [vesselValue, setVesselValue] = useState('');
  const [portsList, setPortsList] = useState([]);
  const [terminalsList, setTerminalsList] = useState([]);
  const [sslsList, setSslsList] = useState([]);
  const selectOp = useSelector((state) => state.reducer);
  const [selectedETA, setSelectedETA] = useState();
  const [selectedETD, setSelectedETD] = useState();
  const [selectedERD, setSelectedERD] = useState();
  const [selectedCotoff, setSelectedCotoff] = useState();
  const [sizeSelectOptions, setSizeSelectOptions] = useState(null);
  const [selectedSIZE, setSelectedSize] = useState(null);
  const [selectedSsl, setSelectedSsl] = useState('All');
  const [terminalOrSsl, setTerminalOrSsl] = useState('terminal');
  const [portSelectOptions, setPortSelectOptions] = useState([]);
  const [terminalsSelectOptions, setTerminalsSelectOptions] = useState([]);
  const [Vessels, setVessels] = useState([]);
  const [LastPage, setLastPage] = useState();
  const [currentPage, setCurrentPage] = useState();
  const currentPageRef = useRef(pagination.currentPage);

  const tableTitles = [
    'Terminal',
    'Vessel',
    'Inbound Voyage',
    'Outbound Voyage',
    'Line',
    'ETA',
    'ATA',
    'ETD',
    'ATD',
    'Empty Pickup',
    'ERD Refer',
    'ERD Dry',
    'Cutoff Refer',
    'Cutoff Hazard',
    'Cutoff Dry',
    'Extended Late Gate',
    'Last Update',
    'ERD Dry',
  ];
  const [tableTitlesList, setTableTitlesList] = useState([
    { name: 'Terminal', sortKey: 'terminal_name' },
    { name: 'Vessel', sortKey: 'name' },
    { name: 'Inbound Voyage', sortKey: 'voyage_in' },
    { name: 'Outbound Voyage', sortKey: 'voyage_out' },
    { name: 'Line', sortKey: 'line' },
    { name: 'ETA', sortKey: 'eta' },
    { name: 'ATA', sortKey: 'ata' },
    { name: 'ETD', sortKey: 'etd' },
    { name: 'ATD', sortKey: 'atd' },
    { name: 'Empty Pickup', sortKey: 'epd' },
    { name: 'ERD Refer', sortKey: 'erd_reefer' },
    { name: 'ERD Dry', sortKey: 'erd_dry' },
    { name: 'Cutoff Refer', sortKey: 'cutoff_reefer' },
    { name: 'Cutoff Hazard', sortKey: 'cutoff_hazard' },
    { name: 'Cutoff Dry', sortKey: 'cutoff_dry' },
    { name: 'Extended Late Gate', sortKey: 'elgd' },
    { name: 'Last Update', sortKey: 'updated_at' },
  ]);
  const tableTitlesListSsh = [
    { name: 'SSL', sortKey: 'sslName' },
    { name: 'Terminal', sortKey: 'terminal_name' },
    { name: 'Vessel', sortKey: 'name' },
    { name: 'Inbound voyage', sortKey: 'voyage' },
    { name: 'Outbound voyage', sortKey: 'outbound_voyage' },
    { name: 'ETA', sortKey: 'eta' },
    { name: 'ATA', sortKey: 'ata' },
    { name: 'ETD', sortKey: 'etd' },
    { name: 'ATD', sortKey: 'atd' },
    { name: 'Empty Pickup', sortKey: 'epd' },
    { name: 'ERD Refer', sortKey: 'erd_reefer' },
    { name: 'ERD Dry', sortKey: 'erd_dry' },
    { name: 'Cutoff Refer', sortKey: 'cutoff_reefer' },
    { name: 'Cutoff Hazard', sortKey: 'cutoff_hazard' },
    { name: 'Cutoff Dry', sortKey: 'cutoff_dry' },
    { name: 'Extended Late Gate', sortKey: 'elgd' },
    { name: 'Last Update', sortKey: 'updated_at' },
  ];
  const tableTitlesListAll = [
    { name: 'Terminal', sortKey: 'render_terminal_slug' },
    { name: 'Vessel', sortKey: 'render_vessel_name' },
    { name: 'Inbound Voyage', sortKey: 'render_voyage_in' },
    { name: 'Outbound Voyage', sortKey: 'render_voyage_out' },
    { name: 'Line', sortKey: 'render_ssl_slug' },
    { name: 'ETA', sortKey: 'render_eta' },
    { name: 'ATA', sortKey: 'render_ata' },
    { name: 'ETD', sortKey: 'render_etd' },
    { name: 'ATD', sortKey: 'render_atd' },
    { name: 'Empty Pickup', sortKey: 'render_epd' },
    { name: 'ERD Refer', sortKey: 'render_erd_reefer' },
    { name: 'ERD Dry', sortKey: 'render_erd_dry' },
    { name: 'Cutoff Refer', sortKey: 'render_cutoff_reefer' },
    { name: 'Cutoff Hazard', sortKey: 'render_cutoff_hazard' },
    { name: 'Cutoff Dry', sortKey: 'render_cutoff_dry' },
    { name: 'Extended Late Gate', sortKey: 'render_elgd' },
    { name: 'Last Update', sortKey: 'render_Updated_at' },
  ];

  const [ddd, setddd] = useState(tableTitlesList);
  useEffect(() => {
    setddd(
      dataTypeChange == 'terminal'
        ? tableTitlesList
        : dataTypeChange == 'all'
        ? tableTitlesListAll
        : tableTitlesListSsh
    );
  }, [dataTypeChange]);

  const req = {
    key: 'vesselTerminalTableTitles',
    data: tableTitlesList,
  };

  useEffect(() => {
    setUserSettings(req)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log('posterr', err);

        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });

    // console.log('updated...');
    getVesselTableTitlesList('vesselTerminalTableTitles')
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  }, [tableTitlesList]); // Empty dependency array to run only once on mount

  const [arrow, setArrow] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: '' });
  const getPortsListFanc = () => {
    setLoading(true);
    getPortsList()
      .then((res) => {
        const portsRes = Object.values(res.data.ports);
        if (portsRes) {
          setPortsList(portsRes); // Set the state directly
        }
        setLoading(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getTerminalsListFanc = () => {
    setLoading(true);
    getTerminalsList()
      .then((res) => {
        const terminalsRes = Object.values(res.data.terminals);
        if (terminalsRes) {
          setTerminalsList(terminalsRes); // Set the state directly
        }
        setLoading(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  const getSslListFanc = () => {
    setLoading(true);
    getSslList()
      .then((res) => {
        console.log('res', res);

        const sslsRes = Object.values(res.data.ssl_list);
        if (sslsRes) {
          setSslsList(sslsRes); // Set the state directly
        }
        setLoading(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const Reset = () => {
    setSelectedPort(portSelectOptions[0]);
    setSelectedTerminal(terminalsSelectOptions[0]);
    setVesselValue('');
    setSelectedSsl(selectOp.ssl[0]);
    setSelectedETA();
    setSelectedETD();
    setSelectedERD();
    setSelectedCotoff();
    setFormData({
      size: null,
      ssl: selectedSsl,
      vessel: '',
      date: new Date(),
      port: portSelectOptions,
      terminal: terminalsSelectOptions[0],
      etaDate: new Date(),
      etdDate: new Date(),
      erdDate: new Date(),
      cotoffDate: new Date(),
    });
  };

  // Use useEffect to fetch data on component mount
  useEffect(() => {
    getPortsListFanc();
    getTerminalsListFanc();
    getSslListFanc();
  }, []); // Empty dependency array to run only once on mount

  // Use useEffect to update portSelectOptions whenever portsList changes
  useEffect(() => {
    if (portsList.length > 0) {
      // Map portsList to create portSelectOptions
      const options = portsList.map((port, index) => ({
        label: port.name,
        slug: port.slug,
        value: index + 1,
      }));

      const hasAllLabel = selectOp.ssl.some((item) => item.label === 'All');
      if (!hasAllLabel) {
        selectOp.ssl.unshift({ label: 'All', value: 0, slug: 'all' });
      }
      setPortSelectOptions(options);
      setSelectedPort(options[0]);
      setSelectedSsl(selectOp.ssl[0]);
    }
  }, [portsList, selectOp]); // Dependencies array with portsList

  useEffect(() => {
    if (terminalsList.length > 0) {
      const options = terminalsList.map((terminal, index) => ({
        label: terminal.name,
        slug: terminal.slug,
        value: index + 1,
      }));
      options.unshift({ label: 'All', value: 0, slug: 'all' });
      setTerminalsSelectOptions(options);
      setSelectedTerminal(options[0]);
    }
  }, [terminalsList]); // Dependencies array with portsList

  const getVesselScheduleList = (
    selectedPort,
    vesselValue,
    selectedTerminal,
    selectedSsl,
    selectedETA,
    selectedETD,
    selectedERD,
    selectedCotoff,
    pagenationCurrent,
    mode
  ) => {
    // console.log('pagenationCurrent', pagenationCurrent);

    // const fApiPage = `page=${pagenationCurrent}`;
    const fApiPage = `page=${mode === 'filter' ? 1 : pagenationCurrent}`;
    const fselectedPort =
      selectedPort != undefined &&
      selectedPort != 'All' &&
      selectedPort.value != 0
        ? `&port=${selectedPort.slug}`
        : '';
    const fvesselValue = vesselValue ? `&vessel=${vesselValue}` : '';
    const fselectedTerminal =
      selectedTerminal &&
      selectedTerminal != 'All' &&
      selectedTerminal.value != 0 &&
      selectedTerminal != undefined
        ? `&terminal=${selectedTerminal.slug}`
        : '';
    const fselectedSsl =
      selectedSsl && selectedSsl != 'All' && selectedSsl.value != 0
        ? `&line=${selectedSsl.label}`
        : '';
    const fselectedETA =
      selectedETA != undefined
        ? `&eta=${formatDate(selectedETA).fullDate}`
        : '';
    const fselectedETD =
      selectedETD != undefined
        ? `&etd=${formatDate(selectedETD).fullDate}`
        : '';
    const fselectedERD =
      selectedERD != undefined
        ? `&erd=${formatDate(selectedERD).fullDate}`
        : '';
    const fselectedCotoff = selectedCotoff
      ? `&cotoff=${formatDate(selectedCotoff).fullDate}`
      : '';

    // console.log('vesselValue', fselectedTerminal);

    const form =
      fApiPage +
      fselectedPort +
      fvesselValue +
      fselectedTerminal +
      fselectedSsl +
      fselectedETA +
      fselectedETD +
      fselectedERD +
      fselectedCotoff;
    // console.log('form11', form);

    if (dataTypeChange == 'terminal') {
      if (mode === 'filter') {
        setLoading(true);

        getVesselSchedule(form)
          .then((res) => {
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);

            const VesselsListtt = res.data.vessels.data;
            setVessels(VesselsListtt);
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
      } else if (mode === 'lazy') {
        // console.log('ssllazyyy');
        getVesselSchedule(form)
          .then((res) => {
            const VesselsListtt = res.data.vessels.data;
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);

            seVesselsEnd((prev) => {
              // console.log('prev', prev);
              // console.log('VesselsListt', VesselsListtt);

              return [...prev, ...VesselsListtt];
            });

            setLazyLoading(false);
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
      } else if (currentPage === LastPage) {
        setLazyLoading(false);
      }
    } else if (dataTypeChange == 'ssl') {
      if (mode === 'filter') {
        setLoading(true);
        getSslVesselSchedule(form)
          .then((res) => {
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);

            const VesselsListt = res.data.vessels.data;
            setVessels(VesselsListt);
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
      } else if (mode === 'lazy') {
        // console.log('ssllazyyy');

        getSslVesselSchedule(form)
          .then((res) => {
            const VesselsListt = res.data.vessels.data;
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);

            seVesselsEnd((prev) => {
              // console.log('prev', prev);
              // console.log('VesselsListt', VesselsListt);

              return [...prev, ...VesselsListt];
            });

            setLazyLoading(false);
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
        setLazyLoading(false);
      } else if (currentPage === LastPage) {
        setLazyLoading(false);
      }
    } else if (dataTypeChange == 'all') {
      // console.log('fApiPage', pagination.currentPage);
      if (mode === 'filter') {
        // console.log('filtereeeeeeeeee');

        setLoading(true);
        getAllVesselSchedule(form)
          .then((res) => {
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);

            const VesselsList = res.data.vessels.data;
            // setVessels((prev) => {
            //   return {
            //     ...prev,
            //     loading: true,
            //     VesselsList: VesselsList,
            //   };
            // });
            // setVessels(VesselsList);
            // When setting the vessels data:
            setVesselsState((prev) => {
              // console.log('prevprev', prev.VesselsList, VesselsList);
              return {
                ...prev,
                loading: true, // or false based on the condition
                VesselsList: VesselsList, // Append new vessels to the existing list
              };
            });
            // setLazyLoading(false);

            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
        // console.log('lazyyyyyyyyyyyyyyy');
      } else if (mode === 'lazy') {
        getAllVesselSchedule(form)
          .then((res) => {
            setLastPage(res.data.vessels?.last_page);
            setCurrentPage(res.data.vessels?.current_page);
            const VesselsList = res.data.vessels.data;
            // setVessels((prev) => {
            //   return {
            //     ...prev,
            //     loading: true,
            //     VesselsList: VesselsList,
            //   };
            // });
            // setVessels(VesselsList);
            // When setting the vessels data:
            setVesselsState((prev) => {
              // console.log('prevprev', prev.VesselsList, VesselsList);

              return {
                ...prev,
                loading: true, // or false based on the condition
                VesselsList: [...prev.VesselsList, ...VesselsList], // Append new vessels to the existing list
              };
            });
            setLazyLoading(false);

            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
            setLoading(false);
          });
        setLazyLoading(false);
      } else if (currentPage === LastPage) {
        setLazyLoading(false);
      }
    }
  };
  // console.log('LastPage', LastPage);
  // console.log('currentPage', currentPage);

  const handleChangeFieldsData = (
    vessel_source,
    vessel_id,
    column_name,
    column_value
  ) => {
    const idx = popupMessage.idx;
    adminChangeVesselFieldData(
      vessel_source,
      vessel_id,
      column_name,
      column_value
    )
      .then((res) => {
        const indexTerminalSlug = idx;
        if (res) {
          // console.log(
          //   'from form',
          //   vessel_source,
          //   vessel_id,
          //   column_name,
          //   column_value,
          //   indexTerminalSlug
          // );
          // console.log('indexTerminalSlug', indexTerminalSlug);
          // console.log('ressssssss', res);
          // console.log('VesselsEnd', VesselsEnd);

          seVesselsEnd((prevTerminals) => {
            if (!prevTerminals || typeof prevTerminals !== 'object') {
              // console.log('prevTerminals is not an object');
              return {};
            }
            if (!res || !res.data || !res.data.vesselSchedule) {
              // console.log('Invalid response or missing vesselSchedule');
              return prevTerminals;
            }

            const newRestriction = {
              ...res.data.vesselSchedule,
              terminal_name: res.data.vesselSchedule.terminal?.slug,
              sslName: res.data.vesselSchedule.shipping_line?.slug,
              line: res.data.vesselSchedule.additional?.ssl,
            };

            // console.log('newRestriction', newRestriction);

            if (indexTerminalSlug === undefined || indexTerminalSlug === null) {
              return prevTerminals;
            }

            return {
              ...prevTerminals,
              [indexTerminalSlug]: newRestriction,
            };
          });
        }
        // console.log('VesselsEndNew', VesselsEnd);
        // notify('Successfully Updated!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Updated!',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
      });
    // notify('Click Kardd!!!😳😳😳');
  };

  useEffect(() => {
    // console.log('api filterrrrrr');

    // Initial load
    getVesselScheduleList(
      selectedPort,
      vesselValue,
      selectedTerminal,
      selectedSsl,
      selectedETA,
      selectedETD,
      selectedERD,
      selectedCotoff,
      pagination.currentPage,
      'filter'
    );
  }, [
    dataTypeChange,
    selectedPort,
    vesselValue,
    selectedTerminal,
    selectedSsl,
    selectedETA,
    selectedETD,
    selectedERD,
    selectedCotoff,
    // lazyLoading,
    // currentPageRef.current,
  ]);
  useEffect(() => {
    // console.log('api lazyyyyyyyyy');
    // Initial load
    getVesselScheduleList(
      selectedPort,
      vesselValue,
      selectedTerminal,
      selectedSsl,
      selectedETA,
      selectedETD,
      selectedERD,
      selectedCotoff,
      pagination.currentPage,
      'lazy'
    );
  }, [pagination.currentPage]);

  // console.log(
  //   'lazyLoading, currentPageRef.current',
  //   lazyLoading,
  //   currentPageRef.current
  // );

  useEffect(() => {
    const handleScrollLoadData = () => {
      // const targetElement = document.getElementById('scrullCheck');

      // if (targetElement) {
      //   const elementPosition = targetElement.getBoundingClientRect().bottom;
      //   const windowHeight = window.innerHeight;
      //   if (elementPosition <= windowHeight + 100) {
      //     console.log(
      //       'Element is within 100 pixels of the bottom of the page!'
      //     );
      //   }
      // }

      // if (dataTypeChange === 'all') {
      const bottom =
        Math.ceil(window.innerHeight + window.scrollY) >=
        document.documentElement.scrollHeight - 100;
      if (bottom && !loading) {
        // Increment the page using the ref
        currentPageRef.current = currentPage + 1;
        setLazyLoading(true);
      }
      console.log('currentPageRef.current', currentPageRef.current);

      // Update the pagination state
      setPagination((prev) => ({
        ...prev,
        currentPage: currentPageRef.current,
      }));
      // }
    };

    window.addEventListener('scroll', handleScrollLoadData);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScrollLoadData);
    };
  }, [lazyLoading, pagination.currentPage, dataTypeChange]);

  // useEffect(() => {}, [VesselsList]);
  function getCurrentWeekDates() {
    const today = new Date();

    // Adjust for Monday-based weeks: getDay() returns 0 for Sunday, 1 for Monday, etc.
    const currentDay = (today.getDay() + 6) % 7; // Adjust so Monday is 0 and Sunday is 6

    const firstDayOfWeek = new Date(today);
    firstDayOfWeek.setDate(today.getDate() - currentDay);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(firstDayOfWeek);
      date.setDate(firstDayOfWeek.getDate() + i);
      dates.push(date);
    }
    return dates;
  }

  // Format the date to separate day, abbreviated month, and year
  function formatDate(date, format) {
    const day = date.getDate().toString().padStart(2, '0');
    const dayNumber = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dayName = dayNames[date.getDay()];
    const monthNumber = String(monthIndex + 1).padStart(2, '0'); // Add leading zero if necessary
    const month = monthNames[monthIndex];
    const fullDate = `${year}/${monthNumber}/${day}`;
    if (format == 1) {
      return `${year}-${monthNumber}-${dayNumber}`;
    } else {
      return { fullDate, day, dayNumber, dayName, monthNumber, month, year };
    }
  }

  const weekDates = getCurrentWeekDates();
  const formattedDates = weekDates.map((date) => formatDate(date));

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = { month: mm, day: dd, year: yyyy };

  const todayIndex = formattedDates.findIndex(
    (date) =>
      date.day === parseInt(today.day) &&
      date.monthNumber === parseInt(today.month) &&
      date.year === today.year
  );

  // const originalDate = "2024-04-20T04:31:52.000000Z";
  const formatUpdatedAtDate = (dateString) => {
    function isInvalidDate(dateStr) {
      return isNaN(Date.parse(dateStr));
    }

    if (dateString == 'please contact your line') {
      return dateString;
    } else if (dateString == 'TBA') {
      return dateString;
    } else if (isInvalidDate(dateString) == true) {
      return '';
    } else {
      const date = new Date(dateString);
      const formattedDate =
        new Date(date).toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
        }) +
        ' ' +
        new Date(date).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });
      // console.log(dateString);
      return formattedDate;
    }
  };

  const amirbiosRef = useRef(null);
  const tableRef = useRef(null);
  const amirbios1Ref = useRef(null);
  const amirbios2Ref = useRef(null);

  const [tableWidth, setTableWidth] = useState(0);
  const [spanWidth, setSpanWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (amirbiosRef.current && amirbios1Ref.current) {
        const amirbiosTop = amirbiosRef.current.getBoundingClientRect().top;

        if (amirbiosTop <= 69) {
          amirbios2Ref.current.classList.add(cls.fix);
          tableRef.current.classList.add(cls.tableTopMargin);
        } else {
          amirbios2Ref.current.classList.remove(cls.fix);
          tableRef.current.classList.remove(cls.tableTopMargin);
        }
      }
      syncScroll('amirbios');
    };
    const updateWidth = () => {
      if (tableRef.current && amirbios1Ref.current) {
        const tableCurrentWidth =
          tableRef.current.getBoundingClientRect().width;
        setTableWidth(tableCurrentWidth);
      }
    };

    const updateHeadWidth = () => {
      if (amirbiosRef.current && amirbios2Ref.current) {
        const tableeCurrentWidth =
          amirbiosRef.current.getBoundingClientRect().width;
        setSpanWidth(tableeCurrentWidth);
      }
    };

    const syncScroll = (source) => {
      if (amirbiosRef.current || amirbios2Ref.current) {
        if (source === 'amirbios') {
          amirbios2Ref.current.scrollLeft = amirbiosRef.current.scrollLeft;
        } else if (source === 'amirbios2') {
          amirbiosRef.current.scrollLeft = amirbios2Ref.current.scrollLeft;
        }
      }
    };

    updateWidth();
    updateHeadWidth();

    window.updateWidth = updateWidth;
    window.updateHeadWidth = updateHeadWidth;
    window.syncScroll = syncScroll;

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateWidth);
    window.addEventListener('resize', updateHeadWidth);
    window.addEventListener('scroll', updateWidth);
    window.addEventListener('scroll', updateHeadWidth);
    if (amirbiosRef.current || amirbios2Ref.current) {
      amirbiosRef.current.addEventListener('scroll', () => {
        syncScroll('amirbios');
      });
      amirbios2Ref.current.addEventListener('scroll', () => {
        syncScroll('amirbios2');
      });
    }

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('resize', updateHeadWidth);
      window.removeEventListener('scroll', updateWidth);
      window.removeEventListener('scroll', updateHeadWidth);
      if (amirbiosRef.current || amirbios2Ref.current) {
        amirbiosRef.current.removeEventListener('scroll', () =>
          syncScroll('amirbios')
        );
        amirbios2Ref.current.removeEventListener('scroll', () =>
          syncScroll('amirbios2')
        );
      }
    };
  }, [loading, vesselsState, Vessels, dataTypeChange, currentPageRef.current]);

  useEffect(() => {
    if (amirbios2Ref.current) {
      amirbios2Ref.current.style.width = `${spanWidth - 4}px`;
    }
  }, [spanWidth]);

  useEffect(() => {
    if (amirbios1Ref.current) {
      amirbios1Ref.current.style.width = `${tableWidth - 4}px`;
    }
  }, [tableWidth]);

  useEffect(() => {
    seVesselsEnd(
      Vessels?.map((vessel) => ({
        ...vessel,
        terminal_name: vessel.terminal?.slug, // Assuming the terminal name is nested under `terminal.name`
        sslName: vessel.shipping_line?.slug, // Assuming the terminal name is nested under `terminal.name`
        line: vessel.additional?.ssl,
      }))
    );
  }, [Vessels]);

  const VesselsEndState = vesselsState.VesselsList?.map((vessel) => ({
    ...vessel,
    terminal_name: vessel.terminal?.slug, // Assuming the terminal name is nested under `terminal.name`
    sslName: vessel.shipping_line?.slug, // Assuming the terminal name is nested under `terminal.name`
    line: vessel.additional?.ssl,
  }));

  const sortBy = (key) => {
    console.log('key', key);

    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
      setArrow(key + 'Down');
    } else {
      setArrow(key + 'Top');
    }
    const sortedVessels = [...VesselsEnd].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    setVessels(sortedVessels);
    setMappedData(sortedVessels);

    const sortedVesselsState = [...VesselsEndState].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    // setVesselsState((prev) => {
    //   return {
    //     loading: true, // or false based on the condition
    //     VesselsList: [...sortedVesselsState], // Append new vessels to the existing list
    //   };
    // });
    const sortedVesselsAll = [...mappedData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    // console.log('sortedVesselsAll', sortedVesselsAll);
    // console.log('sortedVessels', sortedVessels);

    setMappedData(sortedVesselsAll);
    // setVesselsState((prev) => {
    //   return {
    //     loading: true, // or false based on the condition
    //     VesselsList: [...sortedVesselsAll], // Append new vessels to the existing list
    //   };
    // });

    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const table = document.getElementById('table');
    if (!table) {
      console.error('Table element not found');
      return;
    }

    let draggingEle;
    let draggingColumnIndex;
    let placeholder;
    let list;
    let isDraggingStarted = false;

    let x = 0;
    let y = 0;

    const swap = (nodeA, nodeB) => {
      const parentA = nodeA.parentNode;
      const siblingA = nodeA.nextSibling === nodeB ? nodeA : nodeA.nextSibling;

      nodeB.parentNode.insertBefore(nodeA, nodeB);
      parentA.insertBefore(nodeB, siblingA);
    };

    const isOnLeft = (nodeA, nodeB) => {
      const rectA = nodeA.getBoundingClientRect();
      const rectB = nodeB.getBoundingClientRect();

      return rectA.left + rectA.width / 2 < rectB.left + rectB.width / 2;
    };

    const cloneTable = () => {
      const rect = table.getBoundingClientRect();

      list = document.createElement('div');
      list.classList.add('clone-list');
      list.style.position = 'absolute';
      list.style.left = `${rect.left}px`;
      list.style.top = `${rect.top}px`;
      table.parentNode.insertBefore(list, table);

      table.style.visibility = 'hidden';

      const originalCells = Array.from(table.querySelectorAll('tbody td'));
      const originalHeaderCells = Array.from(table.querySelectorAll('th'));
      const numColumns = originalHeaderCells.length;
      originalHeaderCells.forEach((headerCell, headerIndex) => {
        const width = parseInt(window.getComputedStyle(headerCell).width);

        const item = document.createElement('div');
        item.classList.add(cls.draggable);

        const newTable = document.createElement('table');
        newTable.setAttribute('class', 'clone-table');
        newTable.style.width = `${width}px`;

        const th = headerCell.cloneNode(true);
        let newRow = document.createElement('tr');
        newRow.appendChild(th);
        newTable.appendChild(newRow);

        const cells = originalCells.filter(
          (c, idx) => (idx - headerIndex) % numColumns === 0
        );
        cells.forEach((cell) => {
          const newCell = cell.cloneNode(true);
          newCell.style.width = `${width}px`;
          newRow = document.createElement('tr');
          newRow.appendChild(newCell);
          newTable.appendChild(newRow);
        });

        item.appendChild(newTable);
        list.appendChild(item);
      });
    };

    const mouseDownHandler = (e) => {
      const headerCells = Array.from(table.querySelectorAll('th'));
      draggingColumnIndex = headerCells.indexOf(e.target);

      // console.log('Clicked Header:', e.target.textContent); // Check which header is clicked
      // console.log('Dragging Column Index:', draggingColumnIndex);

      x = e.clientX - e.target.offsetLeft;
      y = e.clientY - e.target.offsetTop;

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = (e) => {
      if (!isDraggingStarted) {
        isDraggingStarted = true;

        cloneTable();

        draggingEle = Array.from(list.children)[draggingColumnIndex];
        // console.log('list.children', list.children);
        // console.log('draggingColumnIndex', draggingColumnIndex);
        draggingEle.classList.add(cls.dragging);

        placeholder = document.createElement('div');
        placeholder.classList.add(cls.placeholder);
        draggingEle.parentNode.insertBefore(
          placeholder,
          draggingEle.nextSibling
        );
        placeholder.style.width = `${draggingEle.offsetWidth}px`;
      }

      draggingEle.style.position = 'absolute';
      draggingEle.style.top = `${draggingEle.offsetTop + e.clientY - y}px`;
      draggingEle.style.left = `${draggingEle.offsetLeft + e.clientX - x}px`;

      x = e.clientX;
      y = e.clientY;

      const prevEle = draggingEle.previousElementSibling;
      const nextEle = placeholder.nextElementSibling;

      if (prevEle && isOnLeft(draggingEle, prevEle)) {
        swap(placeholder, draggingEle);
        swap(placeholder, prevEle);
        return;
      }

      if (nextEle && isOnLeft(nextEle, draggingEle)) {
        swap(nextEle, placeholder);
        swap(nextEle, draggingEle);
      }
    };

    const mouseUpHandler = () => {
      if (isDraggingStarted) {
        placeholder && placeholder.parentNode.removeChild(placeholder);

        draggingEle.classList.remove(cls.dragging);
        draggingEle.style.removeProperty('top');
        draggingEle.style.removeProperty('left');
        draggingEle.style.removeProperty('position');

        const endColumnIndex = Array.from(list.children).indexOf(draggingEle);

        list.parentNode.removeChild(list);

        table.querySelectorAll('tr').forEach((row) => {
          const cells = Array.from(row.querySelectorAll('th, td'));
          draggingColumnIndex > endColumnIndex
            ? cells[endColumnIndex].parentNode.insertBefore(
                cells[draggingColumnIndex],
                cells[endColumnIndex]
              )
            : cells[endColumnIndex].parentNode.insertBefore(
                cells[draggingColumnIndex],
                cells[endColumnIndex].nextSibling
              );
        });

        table.style.removeProperty('visibility');

        // Get the current order of headers
        const headers = Array.from(table.querySelectorAll('th')).map((th) =>
          th.textContent.trim()
        );

        // Create a new ordered list based on the current headers
        const newTableTitlesList = headers.map((name) => {
          return (
            tableTitlesList.find((item) => item.name === name) || {
              name,
              sortKey: '',
            }
          );
        });

        // Log the updated header objects as JSON

        // Update the state if necessary
        setTableTitlesList(newTableTitlesList);
      }

      isDraggingStarted = false;

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    // table.querySelectorAll('th').forEach((headerCell) => {
    //   headerCell.classList.add(cls.draggable);
    //   headerCell.addEventListener('mousedown', mouseDownHandler);
    // });

    // Cleanup on component unmount
    return () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };
  }, []);

  useEffect(() => {
    setMappedData(() => {
      return vesselsState?.VesselsList?.map((item) => {
        const result = {};
        // Process each key in the item object
        Object.keys(item).forEach((key) => {
          if (key.startsWith('diff_')) {
            const baseKey = key.replace('diff_', '');
            const terminalKey = key.replace('terminal_', '');
            const sslKey = key.replace('ssl_', '');
            if (item[key] === false) {
              result[`render_${baseKey}`] = item[`show_${baseKey}`];
            } else if (item[key] === true) {
              if (item[`terminal_${baseKey}`]) {
                // console.log('truuuuuuee', baseKey, item[`terminal_${baseKey}`]);
                result[`render_${baseKey}`] = item[`terminal_${baseKey}`];
              } else if (item[`ssl_${baseKey}`]) {
                result[`render_${baseKey}`] = item[`ssl_${baseKey}`];
              }
            }
          }
        });

        // Define render_terminal_info
        const terminalSlug = item.show_terminal?.slug;
        const terminalLink = item.show_terminal?.links?.vessel_schedule;
        const sslSlug = item.show_shipping_line?.slug;
        const sslLink = item.show_shipping_line?.links?.vessel;
        const vesselName = item?.show_name
          ? item.show_name
          : item.ssl_name
          ? item.ssl_name
          : item.terminal_name
          ? item.terminal_name
          : '';
        // const ata = item.terminal_ata ? item.terminal_ata : item.ssl_ata;
        const atd = item.terminal_atd ? item.terminal_atd : item.ssl_atd;
        const erdDry = item.terminal_erd_dry
          ? item.terminal_erd_dry
          : item.ssl_erd_dry;
        const erdReefer = item.terminal_erd_dry
          ? item.terminal_erd_dry
          : item.ssl_erd_reefer;
        const updated_at = item.terminal_updated_at;

        // Add render_terminal_info to the result if terminalSlug exists
        if (terminalSlug) {
          return {
            ...result,
            render_terminal_slug: terminalSlug,
            render_terminal_Link: terminalLink,
            render_ssl_slug: sslSlug,
            render_ssl_link: sslLink,
            render_vessel_name: vesselName,
            // render_ata: ata,
            render_atd: atd,
            render_erd_dry: erdDry,
            render_erd_reefer: erdReefer,
            render_Updated_at: updated_at,
          };
        }

        return result;
      });
    });
  }, [vesselsState]);

  function isDate(data) {
    // Check if the input is a string or a number
    if (typeof data === 'string' || typeof data === 'number') {
      const date = new Date(data);
      // console.log('isDate', !isNaN(date.getTime()));

      // Check if the input is a valid date string and not just a number
      if (!isNaN(date.getTime())) {
        // Return true only if the original input is a date string
        return typeof data === 'string' && !/^\d+$/.test(data);
      }
    }
    return false;
  }

  return (
    <>
      {popupMessage.popUp && (
        <EditFields
          handleChangeFieldsData={handleChangeFieldsData}
          DATA={popupMessage.DATA}
          Label={popupMessage.Label}
          terminalsList={terminalsList}
          sslsList={sslsList}
          selectedTerminal={selectedTerminal}
          vessel_source={dataTypeChange}
          vessel_id={popupMessage.vessel_id}
          column_name={popupMessage.column_name}
          column_value={popupMessage.DATA}
          // restriction_id={popupMessage.restriction_id}
          // shift_column={popupMessage.shift_column}
          // shift_value={popupMessage.shift_value}
          // shift_message={popupMessage.shift_message}
          // ssl_key={popupMessage.key}
          // indexContainer={popupMessage.indexContainer}
          // idx={popupMessage.idx}
          Close={() =>
            setPopupMessage((prev) => {
              return {
                ...prev,
                popUp: false,
              };
            })
          }
        />
      )}

      <div id="emptyCard" className={cls.card}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`Ports `}</span>
              <Select
                placeholder="Ports"
                className={clsx(cls.select)}
                value={selectedPort}
                onChange={(item) => {
                  setForm('port', item);
                  setSelectedPort(item); // Set selected Port state
                }}
                options={portSelectOptions}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`Vessel `}</span>
              <TextField
                type="text"
                key={'a'}
                value={vesselValue}
                placeholder={`Vessel Name`}
                onChange={(e) => {
                  setForm('vessel', e.target.value);
                  setVesselValue(e.target.value);
                }}
                InputProps={{ disableUnderline: true }}
                inputProps={{ min: 0 }}
              />
            </div>
          </Grid>
          {/* <Grid className={cls.hidsection} item xs={0} sm={0} lg={3}></Grid> */}
          <Grid className={cls.terminalLargView} item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`Terminal`}</span>
              <Select
                placeholder="Terminal"
                className={clsx(cls.select)}
                value={selectedTerminal}
                onChange={(item) => {
                  setForm('terminal', item);
                  setSelectedTerminal(item);
                }}
                options={terminalsSelectOptions}
              />
            </div>
          </Grid>

          <Grid className={cls.buttonsDiv} item xs={12} sm={4} lg={3}>
            <div className={cls.containerActions}>
              <div className={cls.containerRowRound}>
                <span
                  onClick={() => setdataTypeChange('all')}
                  className={clsx(
                    cls.chassisText,
                    dataTypeChange == 'all' && cls.activeChassis
                  )}>
                  All
                </span>
                <span
                  onClick={() => setdataTypeChange('terminal')}
                  className={clsx(
                    cls.chassisText,
                    dataTypeChange == 'terminal' && cls.activeChassis
                  )}>
                  Terminal
                </span>
                <span
                  onClick={() => setdataTypeChange('ssl')}
                  className={clsx(
                    cls.chassisText,
                    dataTypeChange == 'ssl' && cls.activeChassis
                  )}>
                  Shipping Line
                </span>
              </div>
            </div>
          </Grid>
          {/* {dataTypeChange == 'all' ? (
            <Grid className={cls.buttonsDiv} item xs={12} sm={4} lg={3}>
              <div className={cls.containerActions}>
                Priority
                <div className={cls.containerRowRound}>
                  <span
                    onClick={() => setPriorityChange('priorityTerminal')}
                    className={clsx(
                      cls.chassisText,
                      priorityChange == 'priorityTerminal' && cls.activeChassis
                    )}>
                    Terminal
                  </span>
                  <span
                    onClick={() => setPriorityChange('prioritySsl')}
                    className={clsx(
                      cls.chassisText,
                      priorityChange == 'prioritySsl' && cls.activeChassis
                    )}>
                    SSL
                  </span>
                </div>
              </div>
            </Grid>
          ) : (
            ''
          )} */}
        </Grid>
        <Grid
          id="hiddenFiltersDiv"
          className={cls.hiddenFiltersDiv}
          container
          spacing={2}>
          <Grid className={cls.hidsection} item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`Terminal `}</span>
              <Select
                placeholder="Terminal"
                className={clsx(cls.select)}
                value={selectedTerminal}
                onChange={(item) => {
                  setForm('terminal', item);
                  setSelectedTerminal(item);
                }}
                options={terminalsSelectOptions}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`SSL `}</span>
              <Select
                placeholder="SSL"
                className={clsx(cls.select)}
                value={selectedSsl}
                onChange={(item) => {
                  setForm('ssl', item);
                  setSelectedSsl(item);
                }}
                options={selectOp.ssl}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`ETA `}</span>
              <DateInput
                placeholder="ETA"
                className={clsx(cls.date)}
                format="MM/dd/yyyy"
                value={form.etaDate}
                onChange={(item) => {
                  setForm('etaDate', item);
                  setSelectedETA(item);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`ETD `}</span>
              <DateInput
                placeholder="ETD"
                className={clsx(cls.date)}
                format="MM/dd/yyyy"
                value={form.etdDate}
                onChange={(item) => {
                  setForm('etdDate', item);
                  setSelectedETD(item);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`ERD `}</span>
              <DateInput
                placeholder="ERD"
                className={clsx(cls.date)}
                format="MM/dd/yyyy"
                value={form.erdDate}
                onChange={(item) => {
                  setForm('erdDate', item);
                  setSelectedERD(item);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={4} lg={3}>
            <div className={`${cls.input} ${cls.containerInput}`}>
              <span className={cls.containerBadge}>{`Cutoff `}</span>
              <DateInput
                placeholder="Cotoff"
                className={clsx(cls.date)}
                format="MM/dd/yyyy"
                value={form.cotoffDate}
                onChange={(item) => {
                  setForm('cotoffDate', item);
                  setSelectedCotoff(item);
                }}
              />
            </div>
          </Grid>
        </Grid>
        <div className={cls.actions}>
          <Grid className={cls.moreLink} container spacing={2}>
            <Grid className={cls.filtersfooter} item xs={12} sm={12} lg={12}>
              <Button className={clsx(cls.but, cls.red)} onClick={Reset}>
                Reset
              </Button>
              {filterOpenStatus == 'open' ? (
                <span
                  onClick={() => {
                    setFilterOpenStatus('close');
                    document.getElementById('hiddenFiltersDiv').style.display =
                      'none';
                  }}
                  className={cls.arrowSpan}>
                  Less Filters
                  <ReactSVG src={Icons.arrowTop} className={cls.arrowTop} />
                </span>
              ) : filterOpenStatus == 'close' ? (
                <span
                  onClick={() => {
                    setFilterOpenStatus('open');
                    document.getElementById('hiddenFiltersDiv').style.display =
                      'flex';
                  }}
                  className={cls.arrowSpan}>
                  More Filters
                  <ReactSVG src={Icons.arrowDown} className={cls.arrowDown} />
                </span>
              ) : (
                ''
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      {dataTypeChange == 'terminal' || dataTypeChange == 'ssl' ? (
        <div ref={amirbiosRef} id="amirbios" className={cls.listContainer}>
          <table ref={tableRef} id="table" className={cls.list}>
            <thead ref={amirbios2Ref} id="amirbios1">
              <tr ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
                {ddd?.map((item, i) => (
                  <th
                    key={i}
                    onClick={() => sortBy(item.sortKey)}
                    style={{ flex: 0.2 }}
                    className={
                      arrow == item.sortKey + 'Top' ||
                      arrow == item.sortKey + 'Down'
                        ? cls.tableTitleSortingThis
                        : cls.tableTitleSorting
                    }>
                    {item.name}
                    {arrow == item.sortKey + 'Top' ? (
                      <span className={cls.arrowSpan}>
                        <ReactSVG
                          src={Icons.arrowTop}
                          className={cls.arrowTop}
                        />
                      </span>
                    ) : arrow == item.sortKey + 'Down' ? (
                      <span className={cls.arrowSpan}>
                        <ReactSVG
                          src={Icons.arrowDown}
                          className={cls.arrowDown}
                        />
                      </span>
                    ) : (
                      ''
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            {loading ? (
              <div className="mt-16">
                <LoadingV2 />
              </div>
            ) : (
              <tbody>
                {Object.values(VesselsEnd).map((idx, i) => (
                  <tr className={cls.tableRow} key={idx.id}>
                    {dataTypeChange == 'ssl' ? (
                      <td
                        onClick={() => {
                          setPopupMessage((prev) => {
                            return {
                              ...prev,
                              popUp: true,
                              DATA:
                                sslsList.find(
                                  (item) => item.id === idx.shipping_line_id
                                )?.slug || idx.shipping_line?.slug,
                              vessel_id: idx.id,
                              column_name: 'shipping_line_id',
                              Label: 'Line',
                              idx: i,
                            };
                          });
                        }}
                        style={{ flex: 0.2 }}
                        className={
                          idx.admin_moderations?.shipping_line_id
                            ? cls.shifttdAdminManual
                            : cls.shifttdAdmin
                        }>
                        <span style={{ flex: 1 }}>
                          {sslsList.find(
                            (item) => item.id === idx.shipping_line_id
                          )?.slug ||
                            idx.shipping_line?.slug ||
                            idx.additional?.ssl ||
                            '-'}
                        </span>
                      </td>
                    ) : (
                      ''
                    )}
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.terminal_name,
                            vessel_id: idx.id,
                            column_name: 'terminal_id',
                            Label: 'Terminal',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.terminal_id
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span
                        style={{ flex: 1 }}
                        className={cls.terminalsNameLogo}>
                        <img
                          width={50}
                          src={
                            idx.terminal_name == 'APM'
                              ? TerminalsIcon.APM
                              : idx.terminal_name == 'FMS'
                              ? TerminalsIcon.FMS
                              : idx.terminal_name == 'EVERPORT'
                              ? TerminalsIcon.EVERPORT
                              : idx.terminal_name == 'LACT'
                              ? TerminalsIcon.LACT
                              : idx.terminal_name == 'PCT'
                              ? TerminalsIcon.PCT
                              : idx.terminal_name == 'PST'
                              ? TerminalsIcon.PST
                              : idx.terminal_name == 'TRAPAC'
                              ? TerminalsIcon.TRAPAC
                              : idx.terminal_name == 'WBCT'
                              ? TerminalsIcon.WBCT
                              : idx.terminal_name == 'WCC'
                              ? TerminalsIcon.WCC
                              : idx.terminal_name == 'YTI'
                              ? TerminalsIcon.YTI
                              : idx.terminal_name == 'TTI'
                              ? TerminalsIcon.TTI
                              : idx.terminal_name == 'ITS'
                              ? TerminalsIcon.ITS
                              : idx.terminal_name == 'LBCT'
                              ? TerminalsIcon.LBCT
                              : idx.terminal_name == 'MATSON'
                              ? TerminalsIcon.MATSON
                              : idx.terminal_name == 'SSA MARINE'
                              ? TerminalsIcon.SSA
                              : idx.terminal_name == 'SSA STL'
                              ? TerminalsIcon.STL
                              : idx.terminal_name == 'PTS'
                              ? TerminalsIcon.PTS
                              : ''
                          }
                        />
                        {idx.terminal_name || '-'}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.name,
                            vessel_id: idx.id,
                            column_name: 'name',
                            Label: 'Vessel',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.name
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>{idx.name || '-'}</span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.voyage_in,
                            vessel_id: idx.id,
                            column_name: 'voyage_in',
                            Label: 'Inbound Voyage',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.voyage_in
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>{idx.voyage_in || '-'}</span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.voyage_out,
                            vessel_id: idx.id,
                            column_name: 'voyage_out',
                            Label: 'Outbound Voyage',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.voyage_out
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>{idx.voyage_out || '-'}</span>
                    </td>
                    {dataTypeChange == 'terminal' || dataTypeChange == 'all' ? (
                      <td
                        onClick={() => {
                          setPopupMessage((prev) => {
                            return {
                              ...prev,
                              popUp: true,
                              DATA:
                                sslsList.find(
                                  (item) => item.id === idx.shipping_line_id
                                )?.slug || idx.shipping_line?.slug,
                              vessel_id: idx.id,
                              column_name: 'shipping_line_id',
                              Label: 'Line',
                              idx: i,
                            };
                          });
                        }}
                        style={{ flex: 0.2 }}
                        className={
                          idx.admin_moderations?.shipping_line_id
                            ? cls.shifttdAdminManual
                            : cls.shifttdAdmin
                        }>
                        <span style={{ flex: 1 }}>
                          {sslsList.find(
                            (item) => item.id === idx.shipping_line_id
                          )?.slug ||
                            idx.shipping_line?.slug ||
                            idx.additional?.ssl ||
                            '-'}
                        </span>
                      </td>
                    ) : (
                      ''
                    )}
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.eta,
                            vessel_id: idx.id,
                            column_name: 'eta',
                            Label: 'ETA',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.eta
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.eta === null
                          ? '-'
                          : isDate(idx.eta) !== true
                          ? idx.eta
                          : formatUpdatedAtDate(`${idx.eta}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.ata,
                            vessel_id: idx.id,
                            column_name: 'ata',
                            Label: 'ATA',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.ata
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.ata === null
                          ? '-'
                          : isDate(idx.ata) !== true
                          ? idx.ata
                          : formatUpdatedAtDate(`${idx.ata}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.etd,
                            vessel_id: idx.id,
                            column_name: 'etd',
                            Label: 'ETD',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.etd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.etd === null
                          ? '-'
                          : isDate(idx.etd) !== true
                          ? idx.etd
                          : formatUpdatedAtDate(`${idx.etd}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.atd,
                            vessel_id: idx.id,
                            column_name: 'atd',
                            Label: 'ATD',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.atd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.atd === null
                          ? '-'
                          : isDate(idx.atd) !== true
                          ? idx.atd
                          : formatUpdatedAtDate(`${idx.atd}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.epd,
                            vessel_id: idx.id,
                            column_name: 'epd',
                            Label: 'EPD',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.epd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {' '}
                        {idx.epd === null
                          ? '-'
                          : isDate(idx.epd) !== true
                          ? idx.epd
                          : formatUpdatedAtDate(`${idx.epd}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.erd_reefer,
                            vessel_id: idx.id,
                            column_name: 'erd_reefer',
                            Label: 'ERD Refer',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.erd_reefer
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.erd_reefer === null
                          ? '-'
                          : isDate(idx.erd_reefer) !== true
                          ? idx.erd_reefer
                          : formatUpdatedAtDate(`${idx.erd_reefer}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.erd_dry,
                            vessel_id: idx.id,
                            column_name: 'erd_dry',
                            Label: 'ERD Dry',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.erd_dry
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.erd_dry === null
                          ? '-'
                          : isDate(idx.erd_dry) !== true
                          ? idx.erd_dry
                          : formatUpdatedAtDate(`${idx.erd_dry}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.cutoff_reefer,
                            vessel_id: idx.id,
                            column_name: 'cutoff_reefer',
                            Label: 'Cutoff Refer',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.cutoff_reefer
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.cutoff_reefer === null
                          ? '-'
                          : isDate(idx.cutoff_reefer) !== true
                          ? idx.cutoff_reefer
                          : formatUpdatedAtDate(`${idx.cutoff_reefer}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.cutoff_hazard,
                            vessel_id: idx.id,
                            column_name: 'cutoff_hazard',
                            Label: 'Cutoff Hazard',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.cutoff_hazard
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.cutoff_hazard === null
                          ? '-'
                          : isDate(idx.cutoff_hazard) !== true
                          ? idx.cutoff_hazard
                          : formatUpdatedAtDate(`${idx.cutoff_hazard}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.cutoff_dry,
                            vessel_id: idx.id,
                            column_name: 'cutoff_dry',
                            Label: 'Cutoff Dry',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.cutoff_dry
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.cutoff_dry === null
                          ? '-'
                          : isDate(idx.cutoff_dry) !== true
                          ? idx.cutoff_dry
                          : formatUpdatedAtDate(`${idx.cutoff_dry}`)}
                      </span>
                    </td>
                    <td
                      onClick={() => {
                        setPopupMessage((prev) => {
                          return {
                            ...prev,
                            popUp: true,
                            DATA: idx.elgd,
                            vessel_id: idx.id,
                            column_name: 'elgd',
                            Label: 'Elgd',
                            idx: i,
                          };
                        });
                      }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.elgd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.elgd === null
                          ? '-'
                          : isDate(idx.elgd) !== true
                          ? idx.elgd
                          : formatUpdatedAtDate(`${idx.elgd}`)}
                      </span>
                    </td>
                    <td style={{ flex: 0.2 }} className={cls.shifttdAdmin}>
                      <span style={{ flex: 1 }}>
                        {idx.updated_at
                          ? formatUpdatedAtDate(`${idx.updated_at}`)
                          : ''}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      ) : dataTypeChange == 'all' ? (
        <div ref={amirbiosRef} id="amirbios" className={cls.listContainer}>
          <table ref={tableRef} id="table" className={cls.list}>
            <thead ref={amirbios2Ref} id="amirbios1">
              <tr ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
                {ddd?.map((item, i) => (
                  <th
                    key={i}
                    onClick={() => sortBy(item.sortKey)}
                    style={{ flex: 0.2 }}
                    className={
                      arrow == item.sortKey + 'Top' ||
                      arrow == item.sortKey + 'Down'
                        ? cls.tableTitleSortingThis
                        : cls.tableTitleSorting
                    }>
                    {item.name}
                    {arrow == item.sortKey + 'Top' ? (
                      <span className={cls.arrowSpan}>
                        <ReactSVG
                          src={Icons.arrowTop}
                          className={cls.arrowTop}
                        />
                      </span>
                    ) : arrow == item.sortKey + 'Down' ? (
                      <span className={cls.arrowSpan}>
                        <ReactSVG
                          src={Icons.arrowDown}
                          className={cls.arrowDown}
                        />
                      </span>
                    ) : (
                      ''
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            {loading ? (
              <div className="mt-16">
                <LoadingV2 />
              </div>
            ) : (
              <tbody>
                {Object.values(mappedData).map((idx, i) => (
                  <tr className={cls.tableRow} key={idx.id}>
                    <td
                      // onClick={() => {
                      //   setPopupMessage((prev) => {
                      //     return {
                      //       ...prev,
                      //       popUp: true,
                      //       DATA: idx.render_terminal_slug,
                      //       vessel_id: idx.id,
                      //       column_name: 'show_terminal.slug',
                      //       Label: 'Terminal',
                      //       idx: i,
                      //     };
                      //   });
                      // }}
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_terminal_slug
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span
                        style={{ flex: 1 }}
                        className={cls.terminalsNameLogo}>
                        <img
                          width={50}
                          src={
                            idx.render_terminal_slug == 'APM'
                              ? TerminalsIcon.APM
                              : idx.render_terminal_slug == 'FMS'
                              ? TerminalsIcon.FMS
                              : idx.render_terminal_slug == 'EVERPORT'
                              ? TerminalsIcon.EVERPORT
                              : idx.render_terminal_slug == 'LACT'
                              ? TerminalsIcon.LACT
                              : idx.render_terminal_slug == 'PCT'
                              ? TerminalsIcon.PCT
                              : idx.render_terminal_slug == 'PST'
                              ? TerminalsIcon.PST
                              : idx.render_terminal_slug == 'TRAPAC'
                              ? TerminalsIcon.TRAPAC
                              : idx.render_terminal_slug == 'WBCT'
                              ? TerminalsIcon.WBCT
                              : idx.render_terminal_slug == 'WCC'
                              ? TerminalsIcon.WCC
                              : idx.render_terminal_slug == 'YTI'
                              ? TerminalsIcon.YTI
                              : idx.render_terminal_slug == 'TTI'
                              ? TerminalsIcon.TTI
                              : idx.render_terminal_slug == 'ITS'
                              ? TerminalsIcon.ITS
                              : idx.render_terminal_slug == 'LBCT'
                              ? TerminalsIcon.LBCT
                              : idx.render_terminal_slug == 'MATSON'
                              ? TerminalsIcon.MATSON
                              : idx.render_terminal_slug == 'SSA MARINE'
                              ? TerminalsIcon.SSA
                              : idx.render_terminal_slug == 'SSA STL'
                              ? TerminalsIcon.STL
                              : idx.render_terminal_slug == 'PTS'
                              ? TerminalsIcon.PTS
                              : ''
                          }
                        />
                        {idx.render_terminal_slug || '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_vessel_name
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_vessel_name ? idx.render_vessel_name : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_voyage_in
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_voyage_in ? idx.render_voyage_in : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_voyage_out
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_voyage_out ? idx.render_voyage_out : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_ssl_slug
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_ssl_slug ? idx.render_ssl_slug : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_eta
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_eta
                          ? formatUpdatedAtDate(`${idx.render_eta}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_ata
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_ata
                          ? formatUpdatedAtDate(`${idx.render_ata}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_etd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_etd
                          ? formatUpdatedAtDate(`${idx.render_etd}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_atd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_atd
                          ? formatUpdatedAtDate(`${idx.render_atd}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_epd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {' '}
                        {idx.render_epd
                          ? formatUpdatedAtDate(`${idx.render_epd}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_erd_reefer
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_erd_reefer
                          ? formatUpdatedAtDate(`${idx.render_erd_reefer}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_erd_dry
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_erd_dry
                          ? formatUpdatedAtDate(`${idx.render_erd_dry}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_cutoff_reefer
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_cutoff_reefer
                          ? formatUpdatedAtDate(`${idx.render_cutoff_reefer}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_cutoff_hazard
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_cutoff_hazard
                          ? formatUpdatedAtDate(`${idx.render_cutoff_hazard}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_cutoff_dry
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_cutoff_dry
                          ? formatUpdatedAtDate(`${idx.render_cutoff_dry}`)
                          : '-'}
                      </span>
                    </td>
                    <td
                      style={{ flex: 0.2 }}
                      className={
                        idx.admin_moderations?.show_elgd
                          ? cls.shifttdAdminManual
                          : cls.shifttdAdmin
                      }>
                      <span style={{ flex: 1 }}>
                        {idx.render_elgd
                          ? formatUpdatedAtDate(`${idx.render_elgd}`)
                          : '-'}
                      </span>
                    </td>
                    <td style={{ flex: 0.2 }} className={cls.shifttdAdmin}>
                      <span style={{ flex: 1 }}>
                        {idx.render_Updated_at
                          ? formatUpdatedAtDate(`${idx.render_Updated_at}`)
                          : '-'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      ) : (
        ''
      )}
      {lazyLoading === true && (
        <span className={cls.lazyLoadingSpan}>Loading...</span>
      )}
      <span id="scrullCheck"></span>
      {/* <Pagination pagination={pagination} setPagination={setPagination} /> */}
    </>
  );
};
